import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { WebSocketLink } from 'apollo-link-ws';
import { Auth } from 'aws-amplify';

async function idToken() {
  const session = await Auth.currentSession();
  return session.idToken.jwtToken;
}

// Create a WebSocket link:
const wsLink = new WebSocketLink({
  uri: process.env.VUE_APP_GRAPHQL_ENDPOINT,
  options: {
    lazy: true,
    reconnect: true,
    timeout: 30000,
    connectionParams: async () => {
      const token = await idToken();
      const headers = { Authorization: `Bearer ${token}` };
      return { headers };
    },
  },
});

// Cache implementation
const cache = new InMemoryCache();

// Create the apollo client
const apolloClient = new ApolloClient({
  link: wsLink,
  cache,
});

export default apolloClient;
